var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": "facebook"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "facebook",
    lang: "en"
  }, "Facebook Icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60039 19.7367V10.1367H0.400391V6.93674H3.60039V5.21834C3.60039 1.96474 5.18519 0.536743 7.88919 0.536743C9.18439 0.536743 9.86919 0.632743 10.1932 0.676743V3.73674H8.34919C7.20119 3.73674 6.80039 4.34234 6.80039 5.56954V6.93674H10.1644L9.70759 10.1367H6.80039V19.7367H3.60039Z",
    fill: "#FFFEFC"
  })));
}
export default SvgFacebookinline;